/**
 * Index — Logged-in users go to /dashboard, everyone else sees static homepage
 */

import { useEffect } from "react";

export default function Index() {
  useEffect(() => {
    // Check for stored Supabase auth token — if present, user is logged in
    try {
      const hasToken = Object.keys(window.localStorage).some(
        k => k.startsWith("sb-") && k.endsWith("-auth-token")
      );
      if (hasToken) {
        window.location.replace("/dashboard");
        return;
      }
    } catch {}
    // No token — show static homepage
    window.location.replace("/home");
  }, []);

  return null;
}
